import RecommendedCourses from "components/recommendedcoursescard";
import SideFilter from "components/sidefilterr";
import CourseCardSmall from "components/studentcoursecardsm";
import { ERCText } from "components/text";
import Layout from "partials/layout";
import React, { useEffect, useState } from "react";
// import art from 'assets/images/arts.svg'
import commercial from "assets/images/commercial.svg";
// import sciences from 'assets/images/sciences.svg'
import styles from "./vocational.module.scss";
import CourseTags from "components/coursetags";
import CounsellorChatCard from "components/counsellorchatcard";
// import Pagination from "components/pagination/newPagination";
import { PaginationSection } from "components/pagination/newPagination";
import { courses, categories } from "assets/dummy/collections";
import FilterComponent from "components/filterComponent";
import { ERCButton } from "components/button";
// import courses from 'assets/dummy/courses.json'

const VocationalCourses = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filteredCourses, setFilteredCourses] = useState(courses);

  const handleFilterChange = (e) => {
    setFilterValues((prev) => ({ ...prev, [e.name]: e.value }));
  };

  // Filter courses based on the selected filters
  useEffect(() => {
    const applyFilter = (key, array, value) => {
      return value ? array?.filter((item) => item[key] === value) : array;
    };

    setFilteredCourses(() => {
      const classFiltered = applyFilter("class", courses, filterValues?.class);
      const subjectFiltered = applyFilter(
        "subject",
        classFiltered,
        filterValues?.subject
      );
      const categoryFiltered = applyFilter(
        "category",
        subjectFiltered,
        filterValues?.category
      );
      return applyFilter(
        "subCategory",
        categoryFiltered,
        filterValues?.subCategory
      );
    });
  }, [filterValues]);
  // pagination section
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 2;
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentTableData = filteredCourses?.slice(
    firstPostIndex,
    lastPostIndex
  );
  // Calculate total pages
  const totalPosts = filteredCourses?.length;

  // Function to handle changing pages
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <Layout mqcolor="#00296B">
      <div className={styles.body}>
        <div className={styles.teachers_container}>
          <h1 className=" absolute md:top-[34%] top-[20%] leading-[50px] left-[10%] md:text-[50px] text-[46px] font-ManropeSemibold text-white">
            Vocational Courses
          </h1>

          <div className="flex absolute top-[50%] left-[10%] md:text-[18px] text-[14px]  ">
            <h2 className="text-[#a3a3a3]">Home/Teacher's Centre/</h2>
            <h2 className="text-[#FFFFFF]">Professional/Courses</h2>
          </div>
          <div className=" w-full flex justify-center md:py-6 pb-12   px-6">
            {/* Search Input */}
            <input
              className="absolute top-[75%] md:w-[67%] w-[90%]  h-[75px] rounded-lg bg-[#fff] px-5 text-black placeholder-black focus:outline-none"
              placeholder="Search your favorite course"
            />

            {/* Search Button */}
            <div className="absolute top-[77.5%] md:right-[17%] right-[10%]">
              <ERCButton width="120px" size="18px">
                Search
              </ERCButton>
            </div>
          </div>

          <div className={styles.svg_container}>
            <div className={styles.svg1}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="213"
                height="317"
                viewBox="0 0 213 317"
                fill="none"
              >
                <path
                  d="M106.425 0C106.425 0 112.297 110.987 135.17 157.304C158.042 203.62 212.851 215.511 212.851 215.511C212.851 215.511 158.042 227.402 135.17 273.719C112.297 320.036 106.425 431.023 106.425 431.023C106.425 431.023 100.553 320.036 77.6808 273.719C54.8084 227.402 0 215.511 0 215.511C0 215.511 54.8084 203.62 77.6808 157.304C100.553 110.987 106.425 0 106.425 0Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
            <div className={styles.svg2}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="163"
                height="278"
                viewBox="0 0 163 278"
                fill="none"
              >
                <path
                  d="M81.7548 0.664062C81.7548 0.664062 86.2323 71.915 103.673 101.649C121.113 131.383 162.904 139.017 162.904 139.017C162.904 139.017 121.113 146.651 103.673 176.385C86.2323 206.119 81.7548 277.37 81.7548 277.37C81.7548 277.37 77.2774 206.119 59.8371 176.385C42.3969 146.651 0.605469 139.017 0.605469 139.017C0.605469 139.017 42.3969 131.383 59.8371 101.649C77.2774 71.915 81.7548 0.664062 81.7548 0.664062Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
            <div className={styles.svg3}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="214"
                height="326"
                viewBox="0 0 214 326"
                fill="none"
              >
                <path
                  d="M107.33 0.179688C107.33 0.179688 113.202 85.1327 136.074 120.585C158.947 156.037 213.755 165.139 213.755 165.139C213.755 165.139 158.947 174.241 136.074 209.693C113.202 245.145 107.33 330.098 107.33 330.098C107.33 330.098 101.458 245.145 78.5851 209.693C55.7127 174.241 0.904297 165.139 0.904297 165.139C0.904297 165.139 55.7127 156.037 78.5851 120.585C101.458 85.1327 107.33 0.179688 107.33 0.179688Z"
                  fill="white"
                  fill-opacity="0.25"
                />
              </svg>
            </div>
            <div className={styles.svg4}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="163"
                height="223"
                viewBox="0 0 163 223"
                fill="none"
              >
                <path
                  d="M81.2978 -208.525C81.2978 -208.525 85.7752 -97.5384 103.215 -51.2217C120.656 -4.90494 162.447 6.98596 162.447 6.98596C162.447 6.98596 120.656 18.8769 103.215 65.1936C85.7752 111.51 81.2978 222.497 81.2978 222.497C81.2978 222.497 76.8203 111.51 59.3801 65.1936C41.9398 18.8769 0.148438 6.98596 0.148438 6.98596C0.148438 6.98596 41.9398 -4.90494 59.3801 -51.2217C76.8203 -97.5384 81.2978 -208.525 81.2978 -208.525Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
            <div className={styles.svg5}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="208"
                height="199"
                viewBox="0 0 208 199"
                fill="none"
              >
                <path
                  d="M106.574 0.890625C106.574 0.890625 112.446 85.8436 135.318 121.296C158.191 156.748 212.999 165.85 212.999 165.85C212.999 165.85 158.191 174.952 135.318 210.404C112.446 245.856 106.574 330.809 106.574 330.809C106.574 330.809 100.702 245.856 77.8293 210.404C54.9568 174.952 0.148438 165.85 0.148438 165.85C0.148438 165.85 54.9568 156.748 77.8293 121.296C100.702 85.8436 106.574 0.890625 106.574 0.890625Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
          </div>
        </div>
        {/* section 2 */}

        <div className="lg:px-24 md:px-12 p-6 w-full">
          <div className="w-full md:flex-row flex flex-col gap-12">
            <div className="flex flex-col gap-6  md:w-[20%] w-full">
              <div>
                <ERCText width="228px" weight="700" size="24px" lHeight="32px">
                  Explore All Our Vocational Courses
                </ERCText>
              </div>
              <div className={styles.filter}>
                {/* <SideFilter
                  title={"Subjects"}
                  name={"subject"}
                  viewAll
                  data={subjects}
                  onChange={handleFilterChange}
                /> */}
                {/* <SideFilter
                  key={filterValues?.class + "basic"}
                  title={"Basic Education Level"}
                  defaultValue={filterValues?.class}
                  name={"class"}
                  data={basic_schools}
                  onChange={handleFilterChange}
                /> */}
                {/* <SideFilter
                  key={filterValues?.class + "Secondary"}
                  title={"Secondary Education Level"}
                  defaultValue={filterValues?.class}
                  name={"class"}
                  data={secondary_schools}
                  onChange={handleFilterChange}
                /> */}
                <SideFilter
                  title={"Categories"}
                  viewAll
                  defaultValue={filterValues?.class}
                  name={"subCategory"}
                  data={categories}
                  onChange={handleFilterChange}
                />
              </div>
              <div className={styles.recommend}>
                <ERCText
                  align="justify"
                  size="16px"
                  weight="700"
                  lHeight="24px"
                >
                  Recommended Courses
                </ERCText>
                <div className="flex flex-col gap-4">
                  <RecommendedCourses
                    img={
                      "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946723/ERC/maths_vljukk.svg"
                    }
                    title={"Introduction To Further Mathematics For SS1"}
                    category={"Sciences"}
                  />
                  <RecommendedCourses
                    img={
                      "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946732/ERC/civic_kmiysm.svg"
                    }
                    title={"Introduction To Civic Education For JSS1"}
                    category={"Arts & Humanities"}
                  />
                  <RecommendedCourses
                    img={
                      "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718947254/ERC/biz-study_uai6sd.svg"
                    }
                    title={"Introduction To Business Studies For JSS1"}
                    category={"Commercial"}
                  />
                </div>
              </div>
            </div>
            <div className="md:w-[80%] w-full flex flex-col gap-6 ">
              <FilterComponent
                name={"subCategory"}
                onChange={handleFilterChange}
                data={[
                  { value: "", display: "All" },
                  { value: "Arts", display: "Arts" },
                  { value: "Artisans", display: "Artisans" },
                  { value: "Tech", display: "Tech" },
                  {
                    value: "Education & Management",
                    display: "Education & Management",
                  },
                  // { value: 'Food', display: 'Food' },
                ]}
                containerClass={styles.tags}
                render={(item) => <CourseTags tagName={item?.display} />}
              />
              <div className=" grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 h-fit bg-white">
                {currentTableData.map((course) => (
                  <CourseCardSmall
                    duration={course.duration}
                    img={commercial}
                    text={course.subCategory}
                    description={course?.description}
                    title={course?.title}
                  />
                ))}
              </div>
              <div className="w-full px-10 mt-32">
                <PaginationSection
                  totalPosts={totalPosts}
                  postsPerPage={postsPerPage}
                  currentPage={currentPage}
                  setCurrentPage={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.chat_card}>
          <CounsellorChatCard />
        </div>
      </div>
    </Layout>
  );
};

export default VocationalCourses;
